import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './cdf.js';
import __var_2__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Bernoulli distribution cumulative distribution function (CDF).
*
* @module @stdlib/stats/base/dists/bernoulli/cdf
*
* @example
* var cdf = require( '@stdlib/stats/base/dists/bernoulli/cdf' );
*
* var y = cdf( 1.0, 0.5 );
* // returns 1.0
*
* y = cdf( 0.5, 0.1 );
* // returns 0.9
*
* var mycdf = cdf.factory( 0.5 );
* y = mycdf( 3.0 );
* // returns 1.0
*
* y = mycdf( -1.0 );
* // returns 0.0
*/

// MODULES //
var setReadOnly = __var_0__;
var cdf = __var_1__;
var factory = __var_2__;


// MAIN //

setReadOnly( cdf, 'factory', factory );


// EXPORTS //
export default cdf;
